/**
 * A station's OCPP version, as a person reads it.
 *
 * The server stores the WebSocket subprotocol verbatim — `ocpp1.6`,
 * `ocpp2.0.1` — because that is what the station said. This turns it into
 * the name on the spec's cover, and nothing more: a value it does not
 * recognise is shown as sent, since inventing a name for it would be a claim
 * the station never made.
 */

const OCPP_PREFIX = /^ocpp(?=\d)/i;

export function protocolLabel(subprotocol: string): string {
  // 1.6 had a SOAP dialect as well; the "J" says which one this socket is.
  if (subprotocol === "ocpp1.6") return "OCPP 1.6J";
  if (!OCPP_PREFIX.test(subprotocol)) return subprotocol;

  return `OCPP ${subprotocol.replace(OCPP_PREFIX, "")}`;
}

/**
 * What the server agrees to, for telling an operator what to set a refused
 * station to. Mirrors `PROTOCOL_VERSIONS` in `src/ocpp/protocol.ts`; the panel
 * cannot import server code, and the alert's details carry the authoritative
 * list when the two ever disagree.
 */
export const SERVER_PROTOCOLS: readonly string[] = ["ocpp1.6", "ocpp2.0.1"];

export function refusedOfferText(offered: readonly string[]): string {
  // Empty also covers an offer the server filtered to nothing, so this says
  // what is known — nothing usable — rather than claiming nothing was sent.
  if (offered.length === 0) return "no OCPP version the server could read";

  return offered.map(protocolLabel).join(", ");
}
